import React from 'react';

import { ReactComponent as LockIcon } from '@assets/icons/lock-red.svg';

import { toggleLockAndUnlock } from '@services/collectionService';

import { changeDateFormat, getUserInfo } from '@utils/Util';

const ProductLock = ({ lockedBy, lockedByName, lockedDate, callBack, productId }) => {
	const unlockProduct = async (e) => {
		e.stopPropagation();
		if (lockedBy === getUserInfo().id) {
			const { payload } = await toggleLockAndUnlock([productId], false);
			if (payload && callBack) {
				callBack(payload);
			}
		}
	};

	return (
		<div className="lock-card bg-white shadow-1dp d-flex align-items-center justify-content-between position-absolute left-2">
			<div className="icon" onClick={unlockProduct}>
				<LockIcon width={24} height={24} />
			</div>
			<div className="content pl-2">
				<p className="gray_dark_01">
					Edit locked by: {lockedByName}, {changeDateFormat(lockedDate, '', 'Do MMM')}
				</p>
				<p className="gray_dark_01">Contact with “{lockedByName}” to to unlock the techpack edit.</p>
			</div>
		</div>
	);
};

export default ProductLock;
